import Cookie from "js-cookie";
import { AppStore } from "@redux/store/reduxStore";
import { Middleware } from "@reduxjs/toolkit";
import { selectSpace } from "@redux/selectors/entities/spaces";
import { settings } from "shared";
import { hydrateStore } from "@actions/useHydrateStore";

export const cookies: Middleware = (store: AppStore) => next => action => {
  // Save the spaceID from the latest navpoint
  if (hydrateStore.match(action)) {
    const navPoint = action.payload.navPoint;
    if (!navPoint) return;
    const space = selectSpace(store.getState(), navPoint);
    if (space?.access?.isPublic === false) {
      const env = settings.environment,
        key = env === "production" ? "lastSpace" : `lastSpace.${env}`;
      Cookie.set(key, String(navPoint.spaceId), { expires: 365, domain: "lingoapp.com" });
    }
  }
  return next(action);
};
